module.exports = __webpack_public_path__ + "static/media/car-tilt.48fbdd92.svg";